// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Fmp1p","header":"MessagesList_header__21COv","chat":"MessagesList_chat__2CngU"};